import React, { useState } from "react";
import { Formik } from "formik";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import RequiredFieldMessage from "../../common/userMessages/requiredFieldMessage";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { validationSchema } from "../formEntities/backgroundInfoEntities";
import SaveAndContinueUserMessage from "../../common/userMessages/saveAndContinueMessage";

const getTodayString = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


const BackgroundForm = ({
  // showReqFieldMessage,
  updatePage,
  shake,
  handleFormikSubmit,
  userData
  // handleSaveAndContinue,
}) => {
  // Convert MM/DD/YYYY to YYYY-MM-DD for date input
  const toDateInputFormat = (dateStr) => {
    if (!dateStr || dateStr.length !== 10) return "";
    const [month, day, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
  };

  // Convert YYYY-MM-DD to MM/DD/YYYY for storage
  const toStorageFormat = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${month}/${day}/${year}`;
  };

  const styles = {
    errorStyle: {
      border: "2px solid red",
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
    },
    fieldErrMessage: {
      color: "red",
      paddingLeft: "5px",
    },
    errIcon: {
      fontSize: "20px",
      color: "red",
    },
    inputGroupTextStyle: {
      border: "1px solid red",
      background: "white",
    },
    errText: {
      color: "red",
    },
  };

  const handlePageReqs = (data, errors) => {
    if (
      (data.nonCompete === "no" ||
        (data.nonCompete === "yes" &&
          data.nonCompeteCompany.length >= 2 &&
          // values.nonCompeteDate &&
          data.nonCompeteDate.length === 10)) &&
      (data.workInjury === "no" ||
        (data.workInjury === "yes" &&
          data.workInjuryDate.length === 10 &&
          data.workInjuryExplantation.length >= 2)) &&
      (data.workmanComp === "no" ||
        (data.workmanComp === "yes" &&
          data.workCompInjuryDate.length === 10 &&
          data.workCompExplanation.length >= 2)) &&
      (data.disability === "no" ||
        (data.disability === "yes" &&
          data.disabilityCompany.length >= 2 &&
          data.disabilityAmount.length >= 4)) &&
      (data.convictions === "no" ||
        (data.convictions === "yes" &&
          data.convictionsExplanation.length >= 2)) &&
      Object.keys(errors).length === 0
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleValidatations = (values) => {
    const errors = {};

    if (
      values.nonCompeteDate &&
      /((0[1-9]|1[0-2])\/[12]\d{4})/.test(
        values.nonCompeteDate
      )
    ) {
      errors.nonCompeteDate = "Invalid date format.  Use MM/YYYY";
    }

    if (
      values.workInjuryDate &&
      /((0[1-9]|1[0-2])\/[12]\d{4})/.test(
        values.workInjuryDate
      )
    ) {
      errors.workInjuryDate = "Invalid date format.  Use MM/YYYY";
    }

    if (
      values.workCompInjuryDate &&
      /((0[1-9]|1[0-2])\/[12]\d{4})/.test(
        values.workCompInjuryDate
      )
    ) {
      errors.workCompInjuryDate = "Invalid date format.  Use MM/YYYY";
    }

    if (
      values.disabilityAmount &&
      !/^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*\.[0-9]{2}$/i.test(
        values.disabilityAmount
      )
    ) {
      errors.disabilityAmount = "Invalid Format.  Use XX,XXX.XX";
    }

    if (handlePageReqs(values, errors)) {
      setShowReqFieldMessage(false);
    }
    return errors;
  };

  const [showReqFieldMessage, setShowReqFieldMessage] = useState(false);
  const handleSaveAndContinue = (values, errors) => {
    // console.log(errors);
    if (handlePageReqs(values, errors)) {
      setShowReqFieldMessage(false);
    } else {
      shake();
      setShowReqFieldMessage(true);
    }
  };

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={{
        nonCompete: userData.backgroundInfo ? userData.backgroundInfo.nonCompete ? userData.backgroundInfo.nonCompete : "" : "",
        nonCompeteCompany: userData.backgroundInfo ? userData.backgroundInfo.nonCompeteCompany ? userData.backgroundInfo.nonCompeteCompany : "" : "",
        nonCompeteDate: userData.backgroundInfo ? userData.backgroundInfo.nonCompeteDate ? userData.backgroundInfo.nonCompeteDate : "" : "",
        workInjury: userData.backgroundInfo ? userData.backgroundInfo.workInjury ? userData.backgroundInfo.workInjury : "" : "",
        workInjuryDate: userData.backgroundInfo ? userData.backgroundInfo.workInjuryDate ? userData.backgroundInfo.workInjuryDate : "" : "",
        workInjuryExplantation: userData.backgroundInfo ? userData.backgroundInfo.workInjuryExplantation ? userData.backgroundInfo.workInjuryExplantation : "" :  "",
        workCompExplanation: userData.backgroundInfo ? userData.backgroundInfo.workCompExplanation ? userData.backgroundInfo.workCompExplanation : "" : "",
        workmanComp: userData.backgroundInfo ? userData.backgroundInfo.workmanComp ? userData.backgroundInfo.workmanComp : "" : "",
        workCompInjuryDate: userData.backgroundInfo ? userData.backgroundInfo.workCompInjuryDate ? userData.backgroundInfo.workCompInjuryDate : "" : "",
        wmCompExpl: userData.backgroundInfo ? userData.backgroundInfo.wmCompExpl ? userData.backgroundInfo.wmCompExpl : "" : "",
        disability: userData.backgroundInfo ? userData.backgroundInfo.disability ? userData.backgroundInfo.disability : "" : "",
        disabilityCompany: userData.backgroundInfo ? userData.backgroundInfo.disabilityCompany ? userData.backgroundInfo.disabilityCompany : "" : "",
        disabilityAmount: userData.backgroundInfo ? userData.backgroundInfo.disabilityAmount ? userData.backgroundInfo.disabilityAmount : "" : "",
        convictions: userData.backgroundInfo ? userData.backgroundInfo.convictions ? userData.backgroundInfo.convictions : "" : "",
        convictionsExplanation: userData.backgroundInfo ? userData.backgroundInfo.convictionsExplanation ? userData.backgroundInfo.convictionsExplanation : "" : "",
      }}
      validate={(values) => handleValidatations(values)}
      onSubmit={(values) => handleFormikSubmit(values)}
    >
      {({ values, errors, touched, handleChange, handleSubmit, setFieldValue }) => (
        <Container>
          {/* {console.log("Values: ", values)} */}
          <Form noValidate onSubmit={handleSubmit}>
            {/* Non compete  */}
            <section>
              <div className="d-flex align-items-center">
                <h3 className="me-2">Non Compete Agreement</h3>
                <em>Required *</em>
              </div>
              <Row>
                <Col sm={12} className="mb-3 text-start">
                  <p
                    style={
                      errors.nonCompete && touched.nonCompete && styles.errText
                    }
                  >
                    Have you ever signed a non compete agreement? If yes,
                    additional fields will appear to collect additional required
                    information.
                  </p>
                  <Form.Check
                    inline
                    id="non-compete-radio-1"
                    type="radio"
                    label="Yes"
                    value="yes"
                    name="nonCompete"
                    onChange={handleChange}
                    disabled={userData.submissionDate}
                    checked={values.nonCompete === "yes" ? values.nonCompete : null}
                    />
                  <Form.Check
                    inline
                    id="non-compete-radio-2"
                    type="radio"
                    label="No"
                    value="no"
                    name="nonCompete"
                    onChange={handleChange}
                    disabled={userData.submissionDate}
                    checked={values.nonCompete === "no" ? values.nonCompete : null}
                  />
                </Col>
              </Row>
              {values.nonCompete === "yes" && (
                <Row>
                                    <Col sm={12} md={6} className="mb-3 text-start">
                    <Form.Group className="mb-3" controlId="nonCompDate">
                      <Form.Label>Date Signed</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          max={getTodayString()}
                          name="nonCompeteDate"
                          onChange={(e) => setFieldValue("nonCompeteDate", toStorageFormat(e.target.value))}
                          style={
                            errors.nonCompeteDate && touched.nonCompeteDate
                              ? styles.errorStyle
                              : null
                          }
                          disabled={userData.submissionDate}
                          value={toDateInputFormat(values.nonCompeteDate)}
                        />
                        {errors.nonCompeteDate && touched.nonCompeteDate && (
                          <InputGroup.Text style={styles.inputGroupTextStyle}>
                            <AiOutlineExclamationCircle
                              style={styles.errIcon}
                            />
                          </InputGroup.Text>
                        )}
                      </InputGroup>
                      {errors.nonCompeteDate && touched.nonCompeteDate ? (
                        <div style={styles.fieldErrMessage}>
                          {errors.nonCompeteDate}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} className="mb-3 text-start">
                    <Form.Group className="mb-3" controlId="nonCompeteCompany">
                      <Form.Label>Company name</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Enter company name"
                          name="nonCompeteCompany"
                          onChange={handleChange}
                          style={
                            errors.nonCompeteCompany &&
                            touched.nonCompeteCompany
                              ? styles.errorStyle
                              : null
                          }
                          disabled={userData.submissionDate}
                          value={values.nonCompeteCompany ? values.nonCompeteCompany : ""}
                        />
                        {errors.nonCompeteCompany &&
                          touched.nonCompeteCompany && (
                            <InputGroup.Text style={styles.inputGroupTextStyle}>
                              <AiOutlineExclamationCircle
                                style={styles.errIcon}
                              />
                            </InputGroup.Text>
                          )}
                      </InputGroup>
                      {errors.nonCompeteCompany && touched.nonCompeteCompany ? (
                        <div style={styles.fieldErrMessage}>
                          {errors.nonCompeteCompany}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>

                </Row>
              )}
            </section>
            <hr />

            {/* Work related injury  */}
            <section>
              <div className="d-flex align-items-center">
                <h3 className="me-2">Work Related Injury</h3>
                <em>Required *</em>
              </div>
              <Row>
                <Col sm={12} className="mb-3 text-start">
                  <p
                    style={
                      errors.workInjury && touched.workInjury && styles.errText
                    }
                  >
                    Have you ever had a work related injury? If yes, additional
                    fields will appear to collect additional required
                    information.
                  </p>
                  <Form.Group>
                    <Form.Check
                      inline
                      id="work-inj-radio-1"
                      type="radio"
                      label="Yes"
                      value="yes"
                      name="workInjury"
                      onChange={handleChange}
                      disabled={userData.submissionDate}
                      checked={values.workInjury === "yes" ? values.workInjury : null}
                    />
                    <Form.Check
                      inline
                      id="work-inj-radio-2"
                      type="radio"
                      label="No"
                      value="no"
                      name="workInjury"
                      onChange={handleChange}
                      disabled={userData.submissionDate}
                      checked={values.workInjury === "no" ? values.workInjury : null}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {values.workInjury === "yes" && (
                <Row>
                  <Col sm={12} md={6} className="mb-3 text-start">
                    <Form.Group
                      className="mb-3"
                      controlId="workRelatedInjuryDate"
                    >
                      <Form.Label>Injury Date</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          max={getTodayString()}
                          name="workInjuryDate"
                          onChange={(e) => setFieldValue("workInjuryDate", toStorageFormat(e.target.value))}
                          style={
                            errors.workInjuryDate && touched.workInjuryDate
                              ? styles.errorStyle
                              : null
                          }
                          disabled={userData.submissionDate}
                          value={toDateInputFormat(values.workInjuryDate)}
                        />
                        {errors.workInjuryDate && touched.workInjuryDate && (
                          <InputGroup.Text style={styles.inputGroupTextStyle}>
                            <AiOutlineExclamationCircle
                              style={styles.errIcon}
                            />
                          </InputGroup.Text>
                        )}
                      </InputGroup>
                      {errors.workInjuryDate && touched.workInjuryDate ? (
                        <div style={styles.fieldErrMessage}>
                          {errors.workInjuryDate}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} className="mb-3 text-start">
                    <Form.Group
                      className="mb-3"
                      controlId="workRelatedInjuryExplanation"
                    >
                      <Form.Label>If yes, please explain</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="workInjuryExplantation"
                        onChange={handleChange}
                        style={
                          errors.workInjuryExplantation &&
                          touched.workInjuryExplantation
                            ? styles.errorStyle
                            : null
                        }
                        disabled={userData.submissionDate}
                        value={values.workInjuryExplantation ? values.workInjuryExplantation : ""}
                      />
                      {errors.workInjuryExplantation &&
                      touched.workInjuryExplantation ? (
                        <div style={styles.fieldErrMessage}>
                          {errors.workInjuryExplantation}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              )}
            </section>
            <hr />

            {/* Workman's Comp */}
            <section>
              <div className="d-flex align-items-center">
                <h3 className="me-2">Workman's Comp</h3>
                <em>Required *</em>
              </div>
              <Row>
                <Col sm={12} className="mb-3 text-start">
                  <p
                    style={
                      errors.workmanComp &&
                      touched.workmanComp &&
                      styles.errText
                    }
                  >
                    Have you ever received workman's comp? If yes, additional
                    fields will appear to collect additional required
                    information.
                  </p>
                  <Form.Check
                    inline
                    id="work-comp-radio-1"
                    type="radio"
                    label="Yes"
                    value="yes"
                    name="workmanComp"
                    onChange={handleChange}
                    disabled={userData.submissionDate}
                    checked={values.workmanComp === "yes" ? values.workmanComp : null}
                  />
                  <Form.Check
                    inline
                    id="work-comp-radio-2"
                    type="radio"
                    label="No"
                    value="no"
                    name="workmanComp"
                    onChange={handleChange}
                    disabled={userData.submissionDate}
                    checked={values.workmanComp === "no" ? values.workmanComp : null}
                  />
                </Col>
              </Row>
              {values.workmanComp === "yes" && (
                <Row>
                  <p className="text-start">
                    Please provide additional information
                  </p>
                  <Col sm={12} md={6} className="mb-3 text-start">
                    <Form.Group className="mb-3" controlId="workCompInjuryDate">
                      <Form.Label>Injury Date</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="date"
                          max={getTodayString()}
                          name="workCompInjuryDate"
                          onChange={(e) => setFieldValue("workCompInjuryDate", toStorageFormat(e.target.value))}
                          style={
                            errors.workCompInjuryDate &&
                            touched.workCompInjuryDate
                              ? styles.errorStyle
                              : null
                          }
                          disabled={userData.submissionDate}
                          value={toDateInputFormat(values.workCompInjuryDate)}
                        />
                        {errors.workCompInjuryDate &&
                          touched.workCompInjuryDate && (
                            <InputGroup.Text style={styles.inputGroupTextStyle}>
                              <AiOutlineExclamationCircle
                                style={styles.errIcon}
                              />
                            </InputGroup.Text>
                          )}
                      </InputGroup>
                      {errors.workCompInjuryDate &&
                      touched.workCompInjuryDate ? (
                        <div style={styles.fieldErrMessage}>
                          {errors.workCompInjuryDate}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} className="mb-3 text-start">
                    <Form.Group
                      className="mb-3"
                      controlId="workCompExplanation"
                    >
                      <Form.Label>
                        If yes, please explain all injuries. Include dates if
                        multiple injuries.
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        onChange={handleChange}
                        style={
                          errors.workCompExplanation &&
                          touched.workCompExplanation
                            ? styles.errorStyle
                            : null
                        }
                        disabled={userData.submissionDate}
                        value={values.workCompExplanation ? values.workCompExplanation : ""}
                      />
                      {errors.workCompExplanation &&
                      touched.workCompExplanation ? (
                        <div style={styles.fieldErrMessage}>
                          {errors.workCompExplanation}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              )}
            </section>
            <hr />

            {/* Disability  */}
            <section>
              <div className="d-flex align-items-center">
                <h3 className="me-2">Disability</h3>
                <em>Required *</em>
              </div>
              <Row>
                <Col sm={12} className="mb-3 text-start">
                  <p
                    style={
                      errors.disability && touched.disability && styles.errText
                    }
                  >
                    Have you ever received disability? If yes, additional fields
                    will appear to collect additional required information.
                  </p>
                  <Form.Check
                    inline
                    id="disability-radio-1"
                    type="radio"
                    label="Yes"
                    value="yes"
                    name="disability"
                    onChange={handleChange}
                    disabled={userData.submissionDate}
                    checked={values.disability === "yes" ? values.disability : null}
                  />
                  <Form.Check
                    inline
                    id="disability-radio-2"
                    type="radio"
                    label="No"
                    value="no"
                    name="disability"
                    onChange={handleChange}
                    disabled={userData.submissionDate}
                    checked={values.disability === "no" ? values.disability : null}
                  />
                </Col>
              </Row>
              {values.disability === "yes" && (
                <Row>
                                    <Col sm={12} md={6} className="mb-3 text-start">
                    <Form.Group className="mb-3" controlId="disabilityAmount">
                      <Form.Label>Disability Amount</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="$0,000.00"
                          name="disabilityAmount"
                          onChange={handleChange}
                          style={
                            errors.disabilityAmount && touched.disabilityAmount
                              ? styles.errorStyle
                              : null
                          }
                          disabled={userData.submissionDate}
                          value={values.disabilityAmount ? values.disabilityAmount : ""}
                        />
                        {errors.disabilityAmount &&
                          touched.disabilityAmount && (
                            <InputGroup.Text style={styles.inputGroupTextStyle}>
                              <AiOutlineExclamationCircle
                                style={styles.errIcon}
                              />
                            </InputGroup.Text>
                          )}
                      </InputGroup>
                      {errors.disabilityAmount && touched.disabilityAmount ? (
                        <div style={styles.fieldErrMessage}>
                          {errors.disabilityAmount}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} className="mb-3 text-start">
                    <Form.Group className="mb-3" controlId="disabilityCompany">
                      <Form.Label>Comany Name</Form.Label>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Enter company name"
                          name="disabilityCompany"
                          onChange={handleChange}
                          style={
                            errors.disabilityCompany &&
                            touched.disabilityCompany
                              ? styles.errorStyle
                              : null
                          }
                          disabled={userData.submissionDate}
                          value={values.disabilityCompany ? values.disabilityCompany : ""}
                        />
                        {errors.disabilityCompany &&
                          touched.disabilityCompany && (
                            <InputGroup.Text style={styles.inputGroupTextStyle}>
                              <AiOutlineExclamationCircle
                                style={styles.errIcon}
                              />
                            </InputGroup.Text>
                          )}
                      </InputGroup>
                      {errors.disabilityCompany && touched.disabilityCompany ? (
                        <div style={styles.fieldErrMessage}>
                          {errors.disabilityCompany}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>

                </Row>
              )}
            </section>
            <hr />

            {/* Prior Convictions  */}
            <section>
              <div className="d-flex align-items-center">
                <h3 className="me-2">Prior Convictions</h3>
                <em>Required *</em>
              </div>
              <Row>
                <Col sm={12} className="mb-3 text-start">
                  <p
                    style={
                      errors.convictions &&
                      touched.convictions &&
                      styles.errText
                    }
                  >
                    Have you ever been convicted of a crime other than minor
                    traffic violations? If yes, additional fields will appear to
                    collect additional required information.
                  </p>
                  <Form.Check
                    inline
                    id="convictions-radio-1"
                    type="radio"
                    label="Yes"
                    value="yes"
                    name="convictions"
                    onChange={handleChange}
                    disabled={userData.submissionDate}
                    checked={values.convictions === "yes" ? values.convictions : null}
                  />
                  <Form.Check
                    inline
                    id="convictions-radio-2"
                    type="radio"
                    label="No"
                    value="no"
                    name="convictions"
                    onChange={handleChange}
                    disabled={userData.submissionDate}
                    checked={values.convictions === "no" ? values.convictions : null}
                  />
                </Col>
              </Row>
              {values.convictions === "yes" && (
                <Row>
                  <Col sm={12} className="mb-3 text-start">
                    <Form.Group
                      className="mb-3"
                      controlId="convictionsExplanation"
                    >
                      <Form.Label>
                        If yes, please list ALL prior convictions and dates
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="convictionsExplanation"
                        onChange={handleChange}
                        style={
                          errors.convictionsExplanation &&
                          touched.convictionsExplanation
                            ? styles.errorStyle
                            : null
                        }
                        disabled={userData.submissionDate}
                        value={values.convictionsExplanation ? values.convictionsExplanation : ""}
                      />
                      {errors.convictionsExplanation &&
                      touched.convictionsExplanation ? (
                        <div style={styles.fieldErrMessage}>
                          {errors.convictionsExplanation}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                </Row>
              )}
            </section>

            {/* Submit Section  */}
            <section>
              <RequiredFieldMessage
                show={showReqFieldMessage ? true : false}
                reqMessage="Complete all required fields before continuing"
              />
              <SaveAndContinueUserMessage messageType="save and continue" />
              <Button
                variant="primary"
                type="submit"
                onClick={() => handleSaveAndContinue(values, errors)}
              >
                Save and Continue
              </Button>
            </section>
          </Form>
        </Container>
      )}
    </Formik>
  );
};

export default BackgroundForm;
